/* eslint-disable*/
import theme from 'theme';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';

const OKicon = ({ sx = {} }) => {
  return (
    <PanoramaFishEyeIcon
      sx={{
        color: '#718CC7',
        fontSize: '32px',
        fontWeight: 'bold',
        mr: 1,
        ...sx // 追加のスタイルを上書き可能に
      }}
    />
  );
};

export default OKicon;
